import { cn } from '@/lib/utils';

type TProps = {
	className?: string;
	email: string;
}

const BannerUserInfosEmail = ({ email, className }: TProps) => {

	if (!email) {
		return <></>;
	}

	return (
		<p className={cn(
			'text-sm text-muted-foreground truncate overflow-hidden',
			className
		)}>
			{email}
		</p>
	);

};

export default BannerUserInfosEmail;
